import * as React from "react";
import clsx from "clsx";
import type { OrgContextOrganization } from "../../lib/organization-context/types";
import * as s from "./OrgContext.css";

export interface OrgContextSummaryProps {
  orgs: OrgContextOrganization[];
  className?: string;
  primary?: boolean;
}

export function OrgContextSummary({
  orgs,
  className,
  primary = false,
}: OrgContextSummaryProps) {
  if (orgs.length === 0) return null;

  const label =
    orgs.length === 1
      ? orgs[0]!.name
      : `${orgs.length} organizations`;

  const tooltipText =
    orgs.length > 1 ? orgs.map((o) => o.name).join("\n") : undefined;

  return (
    <span
      className={clsx(
        s.contextSummary,
        primary && s.contextSummaryPrimary,
        className,
      )}
      title={tooltipText}
      aria-label={tooltipText ? `${orgs.length} organizations: ${orgs.map((o) => o.name).join(", ")}` : undefined}
    >
      {label}
    </span>
  );
}
